<!--
    Created by 王丽莎 on 2025/05/19.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：账户充值
    功能概述：
-->
<style lang="less">
.account-recharge-dialog {
  padding-bottom: @containerGap;
  height: 100%;
  .setting-inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    .setting-inner-box {
      .step-outer {
        padding-top: @containerGap;
        background-color: @backColorStrong;
        border-radius: @borderRadiusMin @borderRadiusMin 0 0;
      }
    }
    .setting-content-box {
      background-color: @backColorStrong;
      border-radius: 0 0 @borderRadiusMin @borderRadiusMin;
    }
    .btn-box {
      padding-top: @containerGap;
      text-align: center;
      .btn {
        &:first-child {
          margin-right: @containerGap;
        }
      }
    }
  }
}
</style>

<template>
  <yg-modal
    width="600"
    title="账户充值"
    :back-type="2"
    :show-bottom="false"
    @on-close="onClose"
  >
    <div
      slot="content"
      class="account-recharge-dialog"
    >
      <div class="setting-inner">
        <div class="setting-inner-box">
          <div
            v-if="isStepMod"
            class="step-outer"
          >
            <yg-steps
              :current-index="tab.index"
              :items="tab.dicItems"
              prev-text=""
              next-text=""
              @on-click="onStepChanged"
            />
          </div>
          <yg-tab-primary
            v-else
            :index="tab.index"
            :permission-items="tab.permissionItems"
            :items="tab.items"
            :type="2"
            @on-change="onTabChanged"
          />
          <div class="padding-primary setting-content-box">
            <v-recharge-amount
              v-show="tab.index === 0"
              :model="model"
              @on-change="onChangeDisabled"
            />
            <v-qr-code
              v-if="tab.index === 1"
              :model="qrCodeModel"
              @on-change="onChangeDisabled"
            />
          </div>
          <div class="btn-box">
            <yg-button
              v-if="tab.index !== 0"
              type="default"
              class="btn"
              @click="_clickPreviousStep"
            >
              上一步
            </yg-button>
            <yg-button
              :disabled="buttonDisabled"
              :disabled-text="buttonDisabledMsg"
              type="primary"
              @click="_clickNextStep"
            >
              {{ tab.index === (tab.dicItems.length - 1) ? '下载二维码' : '下一步' }}
            </yg-button>
          </div>
        </div>
      </div>
    </div>
  </yg-modal>
</template>

<script>
import stepMixin from '@/pages/020__organizationManager/_mixin/stepMixin';
import mixinDivCreateImage from '@/libs/mixins/divCreateImage';
import vRechargeAmount from './rechargeAmount.vue';
import vQrCode from './qrCode.vue';
import UserApiSet from '@/request/api/UserApiSet';
import { getNowTime } from '@/libs/utils';

export default {
  components: { vRechargeAmount, vQrCode },
  mixins: [stepMixin, mixinDivCreateImage],
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      tab: {
        index: 0,
        items: ['选择充值金额', '生成二维码'],
        permissionItems: ['system:custom:recharge:money:list', 'system:customer:account:recharge:pay'],
        dicItems: [
          { title: '步骤1', info: '选择充值金额' },
          { title: '步骤2', info: '生成二维码' }
        ]
      },
      buttonDisabled: true,
      buttonDisabledMsg: '',
      needRefreshList: false,
      qrCodeModel: null
    };
  },
  created () {},
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onClose () {
      this.$emit('on-close', this.needRefreshList);
    },
    onChangeDisabled ({ disabled, msg }) {
      this.buttonDisabled = disabled;
      this.buttonDisabledMsg = msg;
    },
    onTabChanged (e) {
      console.log(e, this.buttonDisabled);
      if (e === this.tab.index) return;
      this.buttonDisabled = false;
      this.buttonDisabledMsg = '';
      this.tab.index = e;
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    // 上一步
    _clickPreviousStep () {
      this.onTabChanged(this.tab.index - 1);
    },
    // 下一步
    _clickNextStep () {
      console.log(this.model);
      const tIndex = this.tab.index;
      if (tIndex === 0) {
        // 请求充值
        const res = this.model.checkValidSubmit();
        if (!res.success) {
          this.$Message.warning(res.msg);
        } else {
          this.requestRecharge(res.params);
        }
      } else if (tIndex === 1) {
        // 生成二维码
        this.mixinImageCreatePic('qrcodeOuter', this.model.tel);
        this.submitFinish();
      }
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求账户充值
    requestRecharge (params) {
      const api = UserApiSet.rechargePay;
      api.params = {
        tel: params.tel,
        money: params.money
      };
      console.log(api);
      this.$http(api).then(res => {
        const { isSuccess } = res.data;
        if (isSuccess === 1) {
          if (res.data && res.data.codeUrl) {
            this.qrCodeModel = {
              codeUrl: res.data.codeUrl,
              money: res.data.rechargeMoney,
              tel: res.data.tel,
              timeExpire: res.data.timeExpire,
              time: getNowTime()
            };
            this.onChangeDisabled({ disabled: true, msg: '无数据变更' });
            this.submitFinish();
          } else {
            this.$Message.warning('缺少重要参数');
          }
        } else {
          this.$Message.warning(res.data.failReason || '缺少重要参数');
          this.qrCodeModel = null;
        }
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
